import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import usePlayerSelector from '../../../../utils/usePlayerSelector';
import { useOktaQueries, Years, Levels } from '../../../../data';
import CatcherStrengthsFilters from '../CatcherStrengthsFilters';
import ReceivingReport from './ReceivingReport';
import useConfig from '../../../../utils/useConfig';

const buildQueries = (haspitchfx = true) => {
    const queries = [
        {
            queryKey: ['years', haspitchfx],
            queryFn: (t) => Years.get(t, { haspitchfx: 2 }),
        },
        {
            queryKey: ['levels', haspitchfx],
            queryFn: (t) => Levels.get(t, { haspitchfx: 2 }),
        },
    ];
    return queries;
};

const mapDataResponse = (response) => {
    const years = response[0].data;
    const levels = response[1].data;
    return { years, levels };
};

const Receiving = () => {
    const { CurrentYear, UsePreviousYearData } = useConfig();
    const { PlayerID, Team } = usePlayerSelector();
    const [filters, setFilters] = useState({ startYear: null, endYear: null, level: null });

    const dataQueries = buildQueries();
    const dataQueriesResponse = useOktaQueries(dataQueries);

    if (dataQueriesResponse.some((q) => q.isLoading)) {
        return <div style={{ margin: '10px' }}><Spinner border="animation" /></div>;
    }

    const { years, levels } = mapDataResponse(dataQueriesResponse);
    const yearOptions = years.map((y) => ({ id: y.YearID, name: y.YearID }));
    const levelOptions = levels.map((l) => ({ id: l.LevelID, name: l.Abbr }));

    const getYearOption = (year) => yearOptions.find((y) => y.id === year) || yearOptions[0];

    const startYear = filters.startYear ?? getYearOption(UsePreviousYearData ? CurrentYear - 1 : CurrentYear);
    const endYear = filters.endYear ?? getYearOption(CurrentYear);
    const level = filters.level || levelOptions.find((l) => l.id === Team.Level.LevelID);

    return (
        <>
            <CatcherStrengthsFilters
                startYearOptions={yearOptions}
                endYearOptions={yearOptions}
                levelOptions={levelOptions}
                startYear={startYear}
                endYear={endYear}
                level={level}
                onSubmit={(updatedFilters) => setFilters(updatedFilters)}
            />
            <ReceivingReport playerID={PlayerID} startYear={startYear.id} endYear={endYear.id} level={level.id} />
        </>
    );
};

export default Receiving;
